<div class="checkout-page-wrapper">
  <p class="mat-title text-darkGray !mb-4 !text-xl text-center">Checkout</p>
  <ng-container *ngrxLet="vm$ as vm">
    <!--  ORDER SUMMARY-->
    <section class="oder-summary-container mb-4">
      <mat-card>
        <mat-card-title class="text-darkGray !mb-4 !inline-flex">
          <mat-icon class="mr-2 opacity-70">receipt_long</mat-icon>
          <p class="mat-title !text-base !mb-0">Order Summary</p>
        </mat-card-title>
        <mat-card-content class="px-8">
          <ng-container *ngIf="vm.loadingBillingPreview; else checkoutSummaryReady">
            <div class="flex min-h-[12rem] items-center justify-center">
              <mat-spinner diameter="32"></mat-spinner>
            </div>
          </ng-container>

          <ng-template #checkoutSummaryReady>
            <ng-container *ngIf="vm.billingPreview; else checkoutSummaryError">
              <app-order-summary
                [data]="vm.orderData"
                [billingPreview]="vm.billingPreview"
                [mode]="'checkout'"
              ></app-order-summary>
            </ng-container>
          </ng-template>

          <ng-template #checkoutSummaryError>
            <div
              *ngIf="vm.hasBillingPreviewLoadError"
              class="py-8 text-center text-[#F44336]"
            >
              Unable to load checkout summary right now. Please try again.
            </div>
          </ng-template>

          <app-checkout-promotion-panel
            [orderId]="vm.currentOrder?.id ?? null"
            [visible]="vm.shouldShowPromoCode"
          ></app-checkout-promotion-panel>
        </mat-card-content>
      </mat-card>
    </section>
    <!--  BILLING ADDRESS-->
    <section *ngIf="activeUser$|async as activeUser"
             class="billing-address-container mb-4">
      <mat-card>
        <mat-card-title class="text-darkGray !mb-4 !inline-flex">
          <mat-icon class="mr-2 opacity-70">location_on</mat-icon>
          <p class="mat-title !text-base !mb-0">Billing address</p>
        </mat-card-title>
        <mat-card-content>
          <ng-container *ngIf="!vm.currentOrder">
            <div class="py-8 text-center text-[#F44336]">
              Unable to load checkout order right now. Please try again.
            </div>
          </ng-container>

          <ng-container *ngIf="vm.currentOrder">
            <ng-container *ngrxLet="this.selectedBillingAddress$ as selectedBillingAddress">
              <ng-container *ngIf="!selectedBillingAddress; else hasAddress">
                <app-empty-billing-address (add)="onAddNewAddress()"></app-empty-billing-address>
              </ng-container>

              <ng-template #hasAddress>
                <app-address-card
                  (changeAddress)="changeSelectedAddress($event)"
                  *ngIf="selectedBillingAddress$|async as selectedBillingAddress"
                  [address]="selectedBillingAddress"
                  [config]="addressCardComponentConfig$|async">
                </app-address-card>
              </ng-template>
            </ng-container>
          </ng-container>
        </mat-card-content>
      </mat-card>
    </section>
    <!--  PAYMENT METHODS-->
    <section class="payment-method-container">
      <mat-card>
        <mat-card-title class="text-darkGray !mb-4 !inline-flex">
          <mat-icon class="mr-2 opacity-70">monetization_on</mat-icon>
          <p class="mat-title !text-base !mb-0">Payment Methods</p>
        </mat-card-title>
        <mat-card-content class="px-8">
          <app-payment-methods
            [country]="country"
            [order]="vm.currentOrder"
            [redirectUrl]="redirectUrl"
            [redirectQueryParams]="redirectQueryParams"
            [shouldRedirect]="shouldRedirect"
          ></app-payment-methods>
        </mat-card-content>
      </mat-card>
    </section>
  </ng-container>
</div>
